<ng-template [ngIf]="type === 'house'">
  <app-house-details-sd
    [property]="property"
    [agency]="agencyService.agency"
    [breadcrumbs]="propertyService.generateBreadcrums(property)"
  >
  </app-house-details-sd>
</ng-template>

<section class="details">
  <div
    fxLayout="column"
    fxLayout.gt-md="row wrap"
    fxLayoutAlign="space-between"
    class="container"
  >
    <div
      class="house-details"
    >
      <ng-template [ngIf]="type === 'house'">
        <div class="aw-item slider">
          <app-images-carousel-base
            [images]="property.images"
          >
            <!-- <div
              class="property-status"
            >
              {{ 'model.property.availability.' + property.availability | translate }}
            </div> -->
          </app-images-carousel-base>
          <a
            mat-raised-button
            color="main-darker"
            fxHide.gt-sm
            [href]="'tel:' + agencyService.agency.phone"
          >
            {{ 'buttons.call_agent' | translate }}
          </a>
        </div>
      </ng-template>

      <div class="aw-item house-description">
        <ng-template [ngIf]="type === 'house'">
          <div
            fxLayout="row wrap"
            fxLayoutAlign="center center"
            fxLayoutAlign.gt-xs="space-between center"
            class="title-container"
          >
            <h2 translate>
              {{ property.title }}
            </h2>
            <label *ngIf="property.for_sale && property.to_let == false">
              {{ property.sale_price | number:'.2' }}{{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
            <label *ngIf="property.to_let && property.for_sale == false">
              {{ property.let_price | number:'.2' }}{{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
            <label *ngIf="property.to_let && property.for_sale">
              {{ property.sale_price | number:'.2' }} {{ 'model.currency_id.' + property.currency_id | translate }} /
              {{ property.let_price | number:'.2' }}{{ 'model.currency_id.' + property.currency_id | translate }}
            </label>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayoutAlign.gt-xs="space-between center"
            class="status-container"
          >
            <label *ngIf="property.sale_status === 'available'">
              VÂNZARE
            </label>
          </div>
        </ng-template>
        <ng-template [ngIf]="type === 'house'">
          <p
            [innerHTML]="property.description"
            class="item-description"
          >
          </p>
        </ng-template>
        <h2
          class="property-description-title"
        >
          {{ 'pages.house_details.subtitles.description' | translate }}
        </h2>
        <div
          fxLayout="row wrap"
          class="description-list"
        >
          <ng-template [ngIf]="type === 'house'">
            <table>
              <tbody>
                <tr *ngIf="property.type_name">
                  <td>
                    {{ 'pages.house_details.property_description.type_name' | translate }}
                  </td>
                  <td>
                    {{ property.type_name }}
                  </td>
                </tr>
                <tr *ngIf="property.floor_value">
                  <td>
                    {{ 'pages.house_details.property_description.floor_value' | translate }}
                  </td>
                  <td>
                    {{ property.floor_value }} {{ 'pages.house_details.property_description.floor_value_of' | translate }} {{ property.floor_count }}
                  </td>
                </tr>
                <tr *ngIf="property.room_count">
                  <td>
                    {{ 'pages.house_details.property_description.room_count' | translate }}
                  </td>
                  <td>
                    {{ property.room_count }}
                  </td>
                </tr>
                <tr *ngIf="property.bathroom_count">
                  <td>
                    {{ 'pages.house_details.property_description.bathroom_count' | translate }}
                  </td>
                  <td>
                    {{ property.bathroom_count }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <tbody>
                <tr *ngIf="property.usable_size_sqm">
                  <td>
                    {{ 'pages.house_details.property_description.usable_size_sqm' | translate }}
                  </td>
                  <td>
                    {{ property.usable_size_sqm | number:'.2' }}
                    m
                    <sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.built_size_sqm">
                  <td>
                    {{ 'pages.house_details.property_description.built_size_sqm' | translate }}
                  </td>
                  <td>
                    {{ property.built_size_sqm | number:'.2' }}
                    m
                    <sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.balcony_size_sqm">
                  <td>
                    {{ 'pages.house_details.property_description.balcony_size_sqm' | translate }}
                  </td>
                  <td>
                    {{ property.balcony_size_sqm | number:'.2' }}
                    m
                    <sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="(property.garden_size_sqm) > 0">
                  <td>
                    {{ 'pages.house_details.property_description.garden_size_sqm' | translate }}
                  </td>
                  <td>
                    {{ property.garden_size_sqm | number:'.2' }}
                    m
                    <sup>2</sup>
                  </td>
                </tr>
                <tr *ngIf="property.total_size_sqm">
                  <td>
                    {{ 'pages.house_details.property_description.total_size_sqm' | translate }}
                  </td>
                  <td>
                    {{ property.total_size_sqm | number:'.2' }}
                    m
                    <sup>2</sup>
                  </td>
                </tr>
              </tbody>
            </table>
          </ng-template>
        </div>
      </div>
      <div
        class="contact-agent"
        fxLayout="column"
        fxLayoutAlign="start start"
      >
        <h2>
          Contact {{ agencyService.agency.name }}
        </h2>
        <div
          fxLayout="column"
          fxLayoutAlign="start center"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
          >
            <img
              src="/assets/icons/contact/phone_grey.svg"
              alt=""
            >
            <a
              [href]="'tel:' + agencyService.agency.phone"
              appGtagEvent
              eventCategory="contact"
              eventAction="click"
              eventLabel="phone_click"
              appFbqEvent="Lead"
              [customData]="{content_name: 'phone_click', content_category: 'click'}"
            >
              {{ agencyService.agency.phone | beautify }}
            </a>
          </div>
          <a
            fxLayout="row"
            fxLayoutAlign="center center"
            [href]="'mailto:' + agencyService.agency.email"
            appGtagEvent
            eventCategory="contact"
            eventAction="click"
            eventLabel="email_click"
            appFbqEvent="Lead"
            [customData]="{content_name: 'email_click', content_category: 'click'}"
            target="_blank"
          >
            <img
              src="/assets/icons/contact/email_grey.svg"
              alt=""
            >
            {{ agencyService.agency.email }}
          </a>
        </div>
      </div>
      <div
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="center center"
      >
        <app-google-map
          [latitude]="item.latitude | parseFloat"
          [longitude]="item.longitude | parseFloat"
          class="aw-item"
        >
          <h2>
            {{ 'pages.house_details.subtitles.localisation' | translate }}
          </h2>
        </app-google-map>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/houses/house-details.component.html